import { useCallback } from "react";

import { useExplorerGlobals } from "contexts/explorerGlobals";

/**
 * Tells the embedding host the user asked to leave the viewer, through the emitter the Webviewer
 * bridge forwards to `webviewer.eventEmitter`.
 *
 * Only reaches a host that subscribed to `viewerCloseRequested` over the command channel, which is
 * what makes it safe to emit alongside the legacy close redirect: a host too old to subscribe
 * receives nothing here and still closes off the redirect.
 */
export function useEmitViewerCloseRequested() {
    const {
        state: { internalEventEmitter },
    } = useExplorerGlobals();

    return useCallback(() => {
        void internalEventEmitter?.emit("viewerCloseRequested", { reason: "user_closed" });
    }, [internalEventEmitter]);
}
